// auto ids
export const ID_RESEND_OTP = 'resend-otp';
export const ID_OTP_VERIFY_BUTTON = 'otp-verify-button';
export const ID_RESET_PASSWORD_SEND_TOTP = 'reset-password-send-totp';
export const ID_RESET_PASSWORD_EMAIL_INIT = 'reset-password-email-init';
export const ID_RESET_PASSWORD_SMS_OTP = 'reset-password-sms-otp';
export const ID_RESET_PASSWORD_EMAIL_OTP = 'reset-password-email-otp';
export const ID_RESET_PASSWORD_UNABLE_TO_ACCESS_EMAIL = 'reset-password-unable-to-access-email';
export const ID_RESET_PASSWORD_UNABLE_TO_ACCESS_MOBILE_SMS = 'reset-password-unable-to-access-mobile-sms';
export const ID_USER_CONSENT_BUTTON = 'user-consent-button';
export const ID_UNAUTHENTICATED = 'unauthenticated';
export const ID_LOGIN_BUTTON = 'loginButton';
export const ID_CREATE_ACCOUNT_BUTTON = 'createAccountButton';
export const ID_DELETE_ACCOUNT_BUTTON = 'deleteAccountButton';
export const ID_SHOW_SESSION_DETAILS_BUTTON = 'showSessionDetailsButton';
export const ID_LOOKUP_INVITATION_BUTTON = 'lookupInvitationButton';
export const ID_APP_TILES_CONTAINER = 'app-tiles-container';
export const ID_APP_TILES_SIDEBAR = 'app-tiles-sidebar';
export const ID_APP_TILES_GROUPED_TILES = 'app-tiles-grouped-tiles';
export const ID_SETTINGS_PAGE_TITLE = 'settings-page-title';
export const ID_FORGOT_PASSWORD_LINK = 'forgot-password-link';
export const ID_PASSWORD_BUTTON = 'password-submit-button';
export const ID_ALIAS_NAME = 'aliasName';
export const ID_ALIAS_TEXT_INPUT = 'alias';
export const ID_ADD_EMAIL_LINK = 'addLink';
export const ID_EDIT_EMAIL_LINK = 'editLink';
export const ID_EDIT_PHONE_LINK = 'editPhoneLink';
export const ID_PHONE_NUMBER = 'phoneNumber';
export const ID_PRIMARY_ALIAS_SWITCH = 'primaryAliasSwitch';
export const ID_REMOVE_ALIAS_BUTTON = 'removeAliasButton';
export const ID_ALIAS_OTP_VERIFY_BUTTON = 'login-email-otp-verify-button';
export const ID_PHONE_ENTRY_BUTTON = 'phone-entry-button';
export const ID_PHONE_SKIP_BUTTON = 'phone-skip-button';
export const ID_CHANGE_PASSWORD_BUTTON = 'changePasswordButton';
export const ID_UPDATE_AUTHENTICATOR_BUTTON = 'updateAuthenticator';
export const ID_REGISTER_AUTHENTICATOR_BUTTON = 'register-authenticator';
export const ID_EMAIL_PREFERENCE_BUTTON = 'emailPreferenceButton';
export const ID_LOCALE_PREFERENCE_BUTTON = 'localePreferenceButton';
export const ID_CHANGE_PASSWORD_BACK_BUTTON = 'changePasswordBackButton';
export const ID_CANCEL_BUTTON = 'cancel-button';
export const ID_DONE_BUTTON = 'done-button';
export const ID_CLOSE_BUTTON = 'close-button';
export const ID_INVITATION_BUTTON = 'invitationButton';
export const ID_INVITATION_EMAIL_OTP_BUTTON = 'invitation-email-otp-verify-button';
export const ID_INVITATION_PHONE_OTP_SUBMIT_BUTTON = 'invitation-phone-otp-verify-button';
export const ID_MOBILE_NUMBER = 'mobileNumber';
export const ID_EMAIL = 'email';
export const ID_VERIFY_OTP_BUTTON = 'verify-otp-button';
export const ID_VERIFY_OTP_BACK_BUTTON = 'verify-otp-back-button';
export const ID_SUBMIT_BUTTON = 'submitButton';
export const ID_LOCALE_SELECT = 'localeSelect';
export const ID_ONBOARDING_LOCALE_SELECT = 'onboardingLocaleSelect';
export const ID_SESSION_LOGOUT_BUTTON = 'sessionLogoutButton';
export const ID_SESSIONS_LOG_OUT_CANCEL_BUTTON = 'sessionLogoutCancelButton';
export const ID_ACTIVE_SESSIONS_ERROR = 'sessionError';
export const ID_SESSIONS_LOG_OUT_CONFIRM_BUTTON = 'sessionLogoutConfirmButton';
export const ID_RESET_AUTHENTICATOR_BUTTON = 'reset-authenticator-button';
export const ID_CURRENT_PASSWORD = 'current-password';
export const ID_NEW_PASSWORD = 'new-password';
export const ID_BACK_TO_SIGN_IN = 'back-to-sign-in';
export const ID_ERROR_PAGE_SUBJECT = 'error-page-subject';
export const ID_SHOW_PASSWORD_ICON = 'showPasswordIcon';
export const ID_PASSWORD = 'password';
export const ID_CONFIRM_PASSWORD = 'confirm-password';
export const ID_AUTHENTICATOR_VERIFY_BUTTON = 'authenticator-verify-button';
export const ID_FIRST_NAME_FIELD = 'first-name';
export const ID_LAST_NAME_FIELD = 'last-name';
export const ID_MY_APP_CARD = 'myAppCard';
export const ID_MY_APP_CARD_INFO_ICON_TEST = 'my-app-card-info-icon';
export const ID_SIGN_OUT = 'signOutButton';
export const ID_RECOVER_ACCOUNT = 'recover-account';
export const ID_CONFIRM_RECOVER_ACCOUNT = 'confirm-recover-account';
export const ID_ACCEPT_RECOVER_ACCOUNT = 'accept-recover-account';
export const ID_MANAGE_ACCOUNT = 'manageAccountLink';
